const getTextWithLink = (text, ...links) => {
    return {__html: links.reduce((accumulator, link) => accumulator.replace('__link__',link), text) };
}

const getTranslations = async(language) => {
    return import(`./${language}.json`).then(module => module);
}

export { getTextWithLink, getTranslations };